var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pt-10 mdmax:pt-6 px-6 mdmax:px-4 pb-20 body"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col justify-between mdmax:justify-start items-center mdmax:items-stretch mb-4 mdmax:gap-4"
  }, [_c('div', {
    staticClass: "relative w-1/3 mdmax:w-full"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('address.list.searchPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.searchCity($event, 'address');
      }
    },
    model: {
      value: _vm.addressSearch,
      callback: function callback($$v) {
        _vm.addressSearch = $$v;
      },
      expression: "addressSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'origin');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('address.dataNotFound')) + " ")])]) : _vm._e()])], 1), _c('div', {
    staticClass: "w-1/6 mdmax:w-full"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('address.list.addAddress'),
      "size": "full"
    },
    on: {
      "action": function action($event) {
        return _vm.addAddress();
      }
    }
  })], 1)]), _c('div', {
    staticClass: "grid grid-cols-2 mdmax:grid-cols-1 gap-x-6"
  }, _vm._l(_vm.filteredAddresses, function (addr, index) {
    return _c('div', {
      key: 'address-' + index,
      staticClass: "mb-5 last:mb-0 flex items-center bg-neutral-200 border border-neutral-300 rounded-md py-3 px-4 gap-3 cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.modifyAddress(addr.id);
        }
      }
    }, [_vm.iconsMapping[addr.asset_icon_id] ? _c('img', {
      attrs: {
        "src": _vm.iconsMapping[addr.asset_icon_id]
      }
    }) : _c('img', {
      attrs: {
        "src": require("@/assets/images/icons/home.svg")
      }
    }), _c('div', [_c('div', {
      staticClass: "flex gap-3 mb-1"
    }, [_c('p', {
      staticClass: "font-medium text-sm "
    }, [_vm._v(_vm._s(addr.location_label))]), addr.is_main ? _c('p', {
      staticClass: "text-xs text-neutral-500 bg-neutral-300 py-1 px-2 rounded-md"
    }, [_vm._v("Utama")]) : _vm._e()]), _c('p', {
      staticClass: "font-medium text-xs text-neutral-500 ellipsis",
      attrs: {
        "title": addr.address
      }
    }, [_vm._v(_vm._s(addr.address) + ", " + _vm._s(addr.detail_address))])])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }